export default "__VITE_ASSET__Bg5DRO9x__"